<template>
  <div class="auswahl">
    <img class="flame" src="@/assets/Flamme.png">
    <button v-if="this.activeView == 'home'" class="menu fa" :class="this.menuActive?'menuActive':'menuDeactive'" @click="this.menuActive = !this.menuActive">&#xf0c9;</button>
    <button v-if="this.activeView != 'home'" class="back fa" @click="this.activeView = 'home'">&#xf104;</button>
    <Menu @closeMenu="this.menuActive = false;" :menuActive="this.menuActive" @toView="this.newView"/>
    <div class="auswahlViews">
        <HomeView v-if="this.activeView == 'home'" @newView="this.newView"/>
        <EinsatzView v-if="this.activeView == 'einsatz'"/>
        <LernView v-if="this.activeView == 'lern-hub'"/>
        <Mehr v-if="this.activeView == 'mehr'"/>
        <FeuerwehrVerwaltung v-if="this.activeView == 'feuerwehrverwaltung'"/>
    </div>
    <FooterNavigation :view="this.activeView" @newView="this.newView"/>
  </div>
</template>
  
<script>
import Menu from '@/components/Home/Menu.vue';
import FooterNavigation from '@/components/Home/FooterNavigation.vue';
import HomeView from './HomeView.vue';
import EinsatzView from './EinsatzView.vue';
import LernView from './LernView.vue';
import Mehr from './Mehr.vue';
import FeuerwehrVerwaltung from './Administrator/FeuerwehrVerwaltung.vue';

export default {
    name: 'home',
    components: {
      Menu,
      FooterNavigation,
      HomeView,
      EinsatzView,
      LernView,
      Mehr,
      FeuerwehrVerwaltung
    },
    data() {
      return{
        menuActive: false,
        activeView: 'home'
      }
    },
    methods:{
        newView(view){
            this.activeView = view;
            sessionStorage.setItem("lastView",view);
            this.menuActive = false;
        }
    },
    async created() {
        if(sessionStorage.getItem("lastView") !== null && sessionStorage.getItem("lastView") !== undefined){
            this.activeView = sessionStorage.getItem("lastView");
        }
    },
}
</script>

<style lang="scss" scoped>
.auswahl {
  min-height: 100vh;
  width: 100vw;
  background-color: rgb(248, 248, 248);
  position: fixed;
  top: 0;
}

.flame{
    height: 4rem;
    display: block;
    position:fixed;
    right: 1rem;
    top: 1rem;
    z-index: 2;
}

.menu, .back{
  width: 2.7rem;
  height: 2.7rem;
  border: solid rgb(236, 236, 236) 1px;
  background-color:white;
  border-radius: 50%;
  //border: none;
  //background-color: transparent;
  color: rgb(34, 34, 34);
  position: fixed;
  left: 2rem;
  top: 2rem;
  z-index: 50;
  //box-shadow: 0 4px 12px rgb(235, 235, 235);
}

.menu:hover, .back:hover{
  //transform: scale(1.05);
  cursor: pointer;
}

.menuActive{
  transform: rotateZ(-90deg);
  transition: transform 0.3s;
}

.menuDeactive{
  transform: rotateZ(0deg);
  transition: transform 0.3s;
}

.back{
    font-size: x-large;
    font-weight: bold;
}
</style>